import type { AdminDashboardStatsResponse } from '@/js/account/entities/dashboard/model/types';
import { onMounted, ref } from 'vue';
import { accountAdminDashboardShow } from '@/js/account/entities/dashboard/api';

export function useAdminDashboardStats() {
  const stats = ref<AdminDashboardStatsResponse | null>(null);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function fetch(): Promise<void> {
    loading.value = true;
    error.value = null;

    try {
      stats.value = await accountAdminDashboardShow();
    }
    catch {
      error.value = 'Failed to load dashboard statistics.';
      stats.value = null;
    }
    finally {
      loading.value = false;
    }
  }

  onMounted(() => {
    void fetch();
  });

  return {
    stats,
    loading,
    error,
    fetch,
  };
}
